import React from "react";
import {Box, Button, Columns, Heading} from "react-bulma-components";
import {useHistory} from "react-router";


export default function AllDropDownLinks(props){
    const {push} = useHistory();

    return (
        <div>
            <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Part Links</Heading>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/partorders")}}
                            fullwidth
                        >
                            Part Orders
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/parthistory")}}
                            fullwidth
                        >
                            Part History
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/partlookup")}}
                            fullwidth
                        >
                            Part Stock
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/parts")}}
                            fullwidth
                        >
                            Part Expenses
                        </Button>
                    </Columns.Column>
                    <Columns.Column></Columns.Column>
                </Columns>
            </Box>
            <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Invoicing</Heading>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/invoicing")}}
                            fullwidth
                        >
                            Workshop Invoicing
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/invoices?activeView=movement")}}
                            fullwidth
                        >
                            Movement Invoicing
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/invoices?activeView=sales")}}
                            fullwidth
                        >
                            Vehicle Sales Invoicing
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/invoices?activeView=order")}}
                            fullwidth
                        >
                            Parts Invoicing
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/invoices?activeView=hire")}}
                            fullwidth
                        >
                            Hire Invoicing
                        </Button>
                    </Columns.Column>
                </Columns>
            </Box>
            <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Vehicles</Heading>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/vehicles")}}
                            fullwidth
                        >
                            Vehicles
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/keys")}}
                            fullwidth
                        >
                            Keys
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/trackers")}}
                            fullwidth
                        >
                            Vehicle Trackers
                        </Button>
                    </Columns.Column>
                    <Columns.Column></Columns.Column>
                    <Columns.Column></Columns.Column>
                </Columns>
            </Box>
            <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Contacts</Heading>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/contacts")}}
                            fullwidth
                        >
                            All Contacts
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/contacts?type=CC")}}
                            fullwidth
                        >
                            Customers
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/contacts?type=SP")}}
                            fullwidth
                        >
                            Suppliers
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/accountbalance")}}
                            fullwidth
                        >
                            Customer Account Balance
                        </Button>
                    </Columns.Column>
                    <Columns.Column></Columns.Column>
                </Columns>
            </Box>
            <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Transactions</Heading>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/po")}}
                            fullwidth
                        >
                            Workshop Expenses
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/fixedexpense")}}
                            fullwidth
                        >
                            Fixed Expenses
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/expenses")}}
                            fullwidth
                        >
                            All Expenses
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={() => {push("/income")}}
                            fullwidth
                        >
                            All Income
                        </Button>
                    </Columns.Column>
                    <Columns.Column></Columns.Column>
                </Columns>
            </Box>
            {/*<Box>*/}
            {/*    <Columns>*/}
            {/*        <Columns.Column>*/}
            {/*            <Heading>Payments</Heading>*/}
            {/*        </Columns.Column>*/}
            {/*    </Columns>*/}
            {/*    <Columns>*/}
            {/*        <Columns.Column>*/}
            {/*            <Button*/}
            {/*                color={"info"}*/}
            {/*                onClick={() => {push("/payments")}}*/}
            {/*                fullwidth*/}
            {/*            >*/}
            {/*                Sale Payments*/}
            {/*            </Button>*/}
            {/*        </Columns.Column>*/}
            {/*        <Columns.Column>*/}
            {/*            <Button*/}
            {/*                color={"info"}*/}
            {/*                onClick={() => {push("/recurringpayments")}}*/}
            {/*                fullwidth*/}
            {/*            >*/}
            {/*                Recurring Payments*/}
            {/*            </Button>*/}
            {/*        </Columns.Column>*/}
            {/*        <Columns.Column></Columns.Column>*/}
            {/*        <Columns.Column></Columns.Column>*/}
            {/*        <Columns.Column></Columns.Column>*/}
            {/*    </Columns>*/}
            {/*</Box>*/}
        </div>
    )

}